


import { createAction as ngrxCreateAction, props, Action } from '@ngrx/store';

export const INIT_SCREEN = '[Master search0] Init';
export const DESTROY_SCREEN = '[Master search0] Destroy';




export const COUNT = '[Master search0] Count';
export const COUNT_SUCCESS = '[Master search0] Count Success';
export const COUNT_FAIL = '[Master search0] Count Fail';
export const SEARCH = '[Master search0] Search';
export const SEARCH_SUCCESS = '[Master search0] Search Success';
export const SEARCH_FAIL = '[Master search0] Search Fail';
export const ROWS_SELECTION_CHANGE = '[Master search0] Rows Selection Change';


export const initAction = ngrxCreateAction(INIT_SCREEN, payload => payload);

export const destroyAction = ngrxCreateAction(DESTROY_SCREEN, payload => payload);



// count action
export const countAction = ngrxCreateAction(COUNT,payload => payload);

export const countSuccessAction = ngrxCreateAction(COUNT_SUCCESS,payload => payload);

export const countFailAction = ngrxCreateAction(COUNT_FAIL,payload => payload);

// search action
export const searchAction = ngrxCreateAction(SEARCH,payload => payload);

export const searchSuccessAction = ngrxCreateAction(SEARCH_SUCCESS,payload => payload);

export const searchFailAction = ngrxCreateAction(SEARCH_FAIL,payload => payload);

export const rowsSelectionChangeAction = ngrxCreateAction(ROWS_SELECTION_CHANGE,payload => payload);




